import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, vShow as _vShow, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "rcornersgrey mx-auto vstack",
  style: {"max-width":"800px","overflow":"initial"}
}
const _hoisted_2 = { class: "text-center" }
const _hoisted_3 = { class: "container" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "callout callout-info" }, "To recover your account, begin by entering your username and then click on the submit button.", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", { for: "txtRecoveryEmail" }, "Username:*", -1)
const _hoisted_6 = {
  id: "buttonWrap",
  class: "mt-4"
}

import { computed, ref, watch, PropType } from 'vue';
import { useUserStore } from '@/stores/userStore';


export default /*#__PURE__*/_defineComponent({
  __name: 'ResetPassword',
  props: {
    title: {}
  },
  emits: [],
  setup(__props: any, { emit: __emit }) {

const props = __props

const recoveryInfo = ref("");
const showAlert = ref(false);

const alertText = computed(()=> {
    return `Account recovery email sent to ${recoveryInfo.value}
If you don’t see this email in your inbox within 15 minutes, look for it in your junk mail folder. If you find it there, please mark it as “Not Junk”.`
});

const userStore = useUserStore();

const emits = __emit;

function handleSubmitClick() {
    userStore.sendPasswordResetRequest(recoveryInfo.value);
    
    showAlert.value = true;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.title), 1),
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _hoisted_5,
      _withDirectives(_createElementVNode("input", {
        type: "text",
        id: "txtRecoveryEmail",
        class: "form-control",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((recoveryInfo).value = $event))
      }, null, 512), [
        [_vModelText, recoveryInfo.value]
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("button", {
          class: "btn btn-lg btn-primary",
          type: "button",
          "aria-label": "submit button",
          onClick: _withModifiers(handleSubmitClick, ["prevent"])
        }, "Submit")
      ]),
      _withDirectives(_createElementVNode("div", {
        class: "alert alert-info mt-1",
        role: "alert"
      }, _toDisplayString(alertText.value), 513), [
        [_vShow, showAlert.value]
      ])
    ])
  ]))
}
}

})